export default {"src":"/_next/static/media/jo.1c05a72a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};